import { render, staticRenderFns } from "./SingleLayerElementSimplified.vue?vue&type=template&id=ac47b8f4&scoped=true"
import script from "./SingleLayerElementSimplified.vue?vue&type=script&lang=ts"
export * from "./SingleLayerElementSimplified.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SingleLayerElementSimplified.vue?vue&type=style&index=0&id=ac47b8f4&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ac47b8f4",
  null
  ,true
)

export default component.exports